import { Container } from "react-bootstrap"

export default function PageNotFound(){
    // displays page not found message

    return (
        <Container className="text-center my-5">
            <h1>Page Not Found</h1><br/>
            <p>Oops! We couldn't find what you were looking for. <br/>
            The page you're looking for might have been removed, had its name changed, or is temporarily unavailable.</p>
        </Container>
    )
}